import React from "react";

import CircleBadge from "../../../../common/CircleBadge";
import LogoLink from "../../../../Header/LogoLink";

import * as styledElements from "./SelectPartHeaderStyles";
import { SelectContainer, SelectOption } from "../../../../common/FancySelect";
import { FONT_SIZE } from "../../../../../constants/Styles";
import { PartSelectionMode } from "../index";

const SelectPartHeader = ({
  closeModal,
  setSelectionMode,
  selectionMode,
}: {
  closeModal: () => void;
  setSelectionMode: (mode: PartSelectionMode) => void;
  selectionMode: PartSelectionMode;
}) => {
  return (
    <styledElements.Container>
      <styledElements.LeftSection>
        <LogoLink />
      </styledElements.LeftSection>
      <styledElements.CenterSection>
        <SelectContainer>
          {[PartSelectionMode.PARTS, PartSelectionMode.CUSTOM].map((mode) => {
            return (
              <SelectOption
                key={mode}
                isSelected={mode === selectionMode}
                onClick={() => setSelectionMode(mode)}
                fontSize={FONT_SIZE.size16}
              >
                {mode}
              </SelectOption>
            );
          })}
        </SelectContainer>
      </styledElements.CenterSection>
      <styledElements.RightSection>
        <CircleBadge
          iconProps={{
            src: "/icons/cancel.svg",
            alt: "cancel",
          }}
          onClick={closeModal}
        />
      </styledElements.RightSection>
    </styledElements.Container>
  );
};

export default SelectPartHeader;
